module.exports = __webpack_public_path__ + "img/3.cec4ea25.png";